import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["modal", "iframe", "loading"]
  
  connect() {
    document.addEventListener("keydown", this.handleKeyDown)
  }
  
  disconnect() {
    document.removeEventListener("keydown", this.handleKeyDown)
  }
  
  handleKeyDown = (e) => {
    if (e.key === "Escape") {
      this.close()
    }
  }
  
  open(event) {
    const contractUrl = event.currentTarget.dataset.contractUrl
    
    this.modalTarget.classList.remove("hidden")
    document.body.style.overflow = "hidden"
    
    this.loadingTarget.classList.remove("hidden")
    this.iframeTarget.classList.add("hidden")
    
    this.iframeTarget.onload = () => {
      this.loadingTarget.classList.add("hidden")
      this.iframeTarget.classList.remove("hidden")
    }
    
    const pdfUrl = contractUrl + "#&navpanes=0&scrollbar=1"
    this.iframeTarget.src = pdfUrl
  }
  
  close() {
    this.modalTarget.classList.add("hidden")
    document.body.style.overflow = ""
    this.iframeTarget.src = ""
  }
  
  openInNewTab() {
    if (this.iframeTarget.src) {
      window.open(this.iframeTarget.src, '_blank')
    }
  }
}